const ComplianceSBTI = () => {
  return "compliance sbti not implemented";
};
export default ComplianceSBTI;
